import styled, { css } from 'styled-components';

export const Textarea = styled.textarea.withConfig({
  shouldForwardProp: (prop) => !['minHeight', 'mb', 'fixed'].includes(prop),
})`
  padding: 8px 8px 11px;
  width: 100%;
  min-height: ${({ minHeight }) => minHeight}px;
  border-radius: 4px;
  border: 1px solid ${(props) => props.theme.colors.link};
  background: ${(props) => props.theme.colors.white};
  margin-bottom: ${({ mb }) => mb}px;

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.focusRing};
    outline-offset: -2px;
  }

  ${({ fixed }) =>
    fixed &&
    css`
      resize: none;
    `}
`;
